import { LegalLayout } from "./components/legalLayout";
import { LGPD } from "./content/lgpd";

/** /lgpd — como a Fidexa cumpre a LGPD. */
export const Lgpd = () => <LegalLayout document={LGPD} />;
